import { useEffect, useRef } from 'react';
import { ContextHolder } from '@frontegg/rest-api';
import AuthService from '../services/auth.service';

export default function Logout() {
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const authService = AuthService.getInstance();

    // Clear all auth state
    sessionStorage.removeItem('plb_auth_state');
    authService.handoffToken = null;
    authService.plbAuthState = null;
    try { ContextHolder.setAccessToken(null as any); } catch (e) { /* */ }

    // Redirect to login
    window.location.replace('/login');
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Logging out...</div>
    </div>
  );
}
